import React, { Component, Fragment } from 'react';
import backgroundImage from '../../assets/links/links_background.png';
import './links.css';
import {LinksButton} from '../../assets/links/LinksButton';
import {LinksProfile} from '../../assets/links/LinksProfile';
import {NameSign} from '../../assets/links/NameSign';
import {IconButton} from '../../assets/links/IconButton';

import {BehanceIcon} from '../../assets/links/buttonIcons/BehanceIcon';
import {RedbubbleIcon} from '../../assets/links/buttonIcons/RedbubbleIcon';
import {ContactIcon} from '../../assets/links/buttonIcons/ContactIcon';
import {PatreonIcon} from '../../assets/links/buttonIcons/PatreonIcon';
import {PortfolioIcon} from '../../assets/links/buttonIcons/PortfolioIcon';
import {InstagramIcon} from '../../assets/links/buttonIcons/InstagramIcon';
import {PinterestIcon} from '../../assets/links/buttonIcons/PinterestIcon';
import {KofiIcon} from '../../assets/links/buttonIcons/KofiIcon';
import ShopIcon from '../../assets/links/buttonIcons/shop_icon.png';

import FontMedium from '../../assets/links/Montserrat-Medium.ttf';
import FontBold from '../../assets/links/Montserrat-Bold.ttf';

export class Links extends Component {
  static displayName = Links.name;

  componentDidMount() {
      window.scrollTo(0, 0);
  }
  
  static translateButtonStyle = `
  .gtranslate_wrapper {
      display: none !important;
  }
  `;

  render () {
    return (
         <Fragment>
             <style>{Links.translateButtonStyle}</style>
             <style> @font-face {'{'} font-family: 'Montserrat-Medium'; src: url({FontMedium}) format('truetype'); {'}'} </style>
             <style> @font-face {'{'} font-family: 'Montserrat-Bold'; src: url({FontBold}) format('truetype'); {'}'} </style>
             <div className="links-content">
                <img src={backgroundImage} className="full-page-background" alt="background" />
                <div className="overlay-content-items">
                    <a href="https://annashepeta.art/" className="overlay-link">
                        <LinksProfile/>
                    </a>
                    <a href="https://annashepeta.art/" className="overlay-link">
                        <NameSign />
                    </a>
                    <a href="https://annashepeta.art/shop" className="overlay-link">
                      <LinksButton iconSrc={ShopIcon} label="Shop" />
                    </a>

                     <a href="https://www.patreon.com/c/AnnaShepeta" className="overlay-link">
                       <LinksButton svgSrc={PatreonIcon} label="Patreon" noTranslate />
                     </a>

                    <a href="https://annashepeta.art/illustration" className="overlay-link">
                      <LinksButton svgSrc={PortfolioIcon} label="Portfolio" />
                    </a>

                     <a href="https://www.behance.net/halbensch" className="overlay-link">
                       <LinksButton svgSrc={BehanceIcon} label="Behance" noTranslate />
                     </a>

                     <a href="https://www.redbubble.com/people/halbensch/shop?asc=u" className="overlay-link">
                       <LinksButton svgSrc={RedbubbleIcon} label="Redbubble" noTranslate />
                     </a>

                     <a href="mailto:annanashepeta@gmail.com" className="overlay-link">
                       <LinksButton svgSrc={ContactIcon} label="Contact" />
                     </a>
                     <div className="d-flex flex-row">
                         <a href="https://www.instagram.com/halber.mensch" className="overlay-link">
                            <IconButton svgSrc={InstagramIcon} />
                          </a>
                         <a href="https://ko-fi.com/halbermensch" className="overlay-link">
                            <KofiIcon />
                          </a>
                         <a href="https://pinterest.com/halbensch/" className="overlay-link">
                            <IconButton svgSrc={PinterestIcon} />
                          </a>
                     </div>
                </div>
             </div>
         </Fragment>
     );
  }
}
